import React from 'react';
import { Redirect } from 'react-router-dom';
import { LayoutRoute, LayoutRouteProps } from './LayoutRoute';
import { useHasAllPermissionsV3 } from 'Utilities/CommonHooks';
import { useGlobalState } from 'Context';
import { FeatureFlags, isFeatureEnabled } from 'Utilities/FeatureFlagProvider';
import { ROUTES } from 'Navigation';

type SecureLayoutRouteV3Props = LayoutRouteProps & {
  permissionsV3: string[];
  flag?: FeatureFlags;
};

export const SecureLayoutRouteV3: React.FC<SecureLayoutRouteV3Props> = ({
  permissionsV3,
  flag,
  ...rest
}) => {
  const hasAll = useHasAllPermissionsV3();
  const { permissionsV3: loadedPermissions } = useGlobalState();

  if (flag && !isFeatureEnabled(flag)) return null;
  if (loadedPermissions === undefined) return null; // still loading — avoid premature redirect
  if (!hasAll(...permissionsV3)) return <Redirect to={ROUTES.UNAUTHORIZED} />;

  return <LayoutRoute {...rest} />;
};
